import { patchQnaEmail } from '@/api';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { ISendReceiptEmailPayload } from '@/types/common.type';
import { Email } from '@repo/components';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { TranslationZone } from '@/styles';
import { routes } from '@/constants/routes.const';

const EmailPage = () => {
  const { passportNumber, email, nationality } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const dispatch = useAppDispatch();
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';
  const history = useHistory();

  const { mutate: patchEmailMutation } = useMutation(
    (payload: ISendReceiptEmailPayload) => patchQnaEmail(payload),
    {
      onSuccess: (email) => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            email,
          },
        });
        history.push(routes.inquiryQna);
      },
      onError: (err: any) => {
        alert(err.message);
      },
    },
  );

  const patchEmail = (email: string) => {
    if (!passportNumber) {
      alert(
        'Please check your passport number. If this problem persists, please try again from first step.',
      );
      return;
    }
    patchEmailMutation({ passportNumber, email });
  };

  return (
    <>
      <TranslationZone />
      <Email
        onBackPage={() => history.goBack()}
        onNext={patchEmail}
        value={email}
        lang={LANG}
      />
    </>
  );
};
export default EmailPage;
